export default "__VITE_ASSET__aFEFW_pE__"